export interface CustomerSalesOrderHistory {
  id: string;
  salesOrderHeaderId: string;
  orderNo: number;
  sequence: number;
  orderDate: Date;
  customerOrderNo: string;
  customerOrderRef: string;
  productKey: string;
  productDescription: string;
  productTypeDescription: string;
  orderQuantity: number;
  orderPrice: number;
  orderValue: number;
  orderSterlingValue: number;
  orderStatus: string;
  despatchNoteNo: number;
  despatchQuantity: number;
  despatchDate: Date;
  invoiceNo: number;
  invoiceDate: Date;
  invoicePrice: number;
  currencyCode: string;
  currencySymbol: string;
  deliveryAddress: string;
}
